export const GMB_DATA_ENUM = {
  GMB_SIMPLE_DATA: 0,
  GMB_WITH_COMPARISON_DATA: 1
};

export const GMB_EXPORT_GROUP_BY = {
  GMB_ADDRESS: "gmb_address"
};
